const NoBubbleDirective = function () {
    return function (scope, element, attrs) {
        element.click(function (e) {
            e.stopPropagation();
        });
    }
};

export { NoBubbleDirective };